// extracted by mini-css-extract-plugin
export var compactFilters = "_h1-4";
export var detailImage = "_h1-1";
export var dropdownContainer = "_h1-2";
export var imageContainer = "_h1-0";
export var selectedCard = "_h1-3";